import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { CredentialProvidersEnum } from '@ghq-abi/auth-client-lib';
import { signIn } from '@ghq-abi/auth-client-lib/client';

export default function Redirect() {
    const hasRedirectedToSignIn = useRef(false);
    const router = useRouter();

    const errorMessage = router.query.error;
    let callbackUrl = router.query.callbackUrl ?? '/';

    if (callbackUrl.includes('i18n')) {
        callbackUrl = '/';
    }

    useEffect(() => {
        if (errorMessage) {
            router.push('/auth/error', { query: { error: errorMessage } });
        } else if (typeof callbackUrl === 'string' && !hasRedirectedToSignIn.current) {
            hasRedirectedToSignIn.current = true;

            signIn(CredentialProvidersEnum.AZURE_AD, { callbackUrl });
        }
    }, [callbackUrl, errorMessage, router]);

    return null;
}

Redirect.unauth = true;
